<div class="settings-page suppliers-page">
  <div class="settings-topbar">
    <div class="topbar-left">
      <h1>
        Suppliers
        <small>Vendor and supplier directory</small>
      </h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i>
        IMS / Settings / <span class="current">Suppliers</span>
      </div>
    </div>
    <div class="topbar-right">
      <button type="button" class="btn btn-primary" (click)="openModal()">
        <i class="bi bi-plus-circle"></i> Add Supplier
      </button>
    </div>
  </div>

  <div class="settings-table-wrap">
    <div class="table-scroll">
      <table class="report-data-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Name</th>
            <th>Contact Person</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Status</th>
            <th class="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (row of suppliers(); track row.id) {
            <tr>
              <td><span class="fw-semibold">{{ row.code }}</span></td>
              <td>{{ row.name }}</td>
              <td>{{ row.contactPerson || '—' }}</td>
              <td>
                @if (row.email) {
                  <a [href]="'mailto:' + row.email" class="contact-link">
                    <i class="bi bi-envelope"></i> {{ row.email }}
                  </a>
                } @else {
                  <span class="text-muted">—</span>
                }
              </td>
              <td>
                @if (row.phone) {
                  <a [href]="'tel:' + row.phone" class="contact-link">
                    <i class="bi bi-telephone"></i> {{ row.phone }}
                  </a>
                } @else {
                  <span class="text-muted">—</span>
                }
              </td>
              <td>
                <span class="status-pill" [class.active]="row.status === 'active'">
                  {{ row.status }}
                </span>
              </td>
              <td class="actions-cell">
                <div class="row-actions">
                  <button type="button" class="btn-action edit" title="Edit supplier" (click)="openEdit(row)">
                    <i class="bi bi-pencil"></i>
                  </button>
                  <button type="button" class="btn-action delete" title="Delete supplier" (click)="deleteRow(row)">
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="7" class="text-center py-4 text-muted">
                <i class="bi bi-inbox empty-state-icon"></i>
                No suppliers found. Click "Add Supplier" to create one.
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>

@if (showModal()) {
  <div class="modal-overlay open" (click)="closeModal()">
    <div class="settings-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2 class="modal-title">
          <i class="bi" [class]="isEditing() ? 'bi-pencil' : 'bi-plus-circle'"></i>
          {{ isEditing() ? 'Edit Supplier' : 'Add Supplier' }}
        </h2>
        <button type="button" class="close-btn" (click)="closeModal()">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label class="form-label">Code <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="supplierForm.code"
            placeholder="Enter supplier code"
          />
        </div>
        <div class="form-group">
          <label class="form-label">Name <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="supplierForm.name"
            placeholder="Enter supplier/company name"
          />
        </div>
        <div class="form-group">
          <label class="form-label">Contact Person <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="supplierForm.contactPerson"
            placeholder="Enter contact person name"
          />
        </div>
        <div class="form-group">
          <label class="form-label">Email</label>
          <input
            type="email"
            class="form-control"
            [(ngModel)]="supplierForm.email"
            placeholder="Enter email address"
          />
        </div>
        <div class="form-group">
          <label class="form-label">Phone</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="supplierForm.phone"
            placeholder="Enter phone number"
          />
        </div>
        <div class="form-group">
          <label class="form-label">Status</label>
          <select class="form-select" [(ngModel)]="supplierForm.status">
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">
          <i class="bi bi-x-lg"></i> Cancel
        </button>
        <button type="button" class="btn btn-primary" (click)="save()">
          <i class="bi bi-check-lg"></i> {{ isEditing() ? 'Save Changes' : 'Save' }}
        </button>
      </div>
    </div>
  </div>
}

@if (showToast()) {
  <div class="toast-container show">
    <div class="toast success">
      <div class="toast-icon"><i class="bi bi-check-circle-fill"></i></div>
      <div class="toast-content">
        <div class="toast-title">Success!</div>
        <div class="toast-message">{{ toastMessage() }}</div>
      </div>
    </div>
  </div>
}
